import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { RobotoTableCell } from "@/shared/components";
import { TriggerType } from "@/shared/domain/actions";

import { type EvaluationColumn } from "./tableColumns";
import { TriggerEvaluationsPagination } from "./TriggerEvaluationsPagination";
import { TriggerEvaluationsTableBody } from "./TriggerEvaluationsTableBody";
import { useTriggerEvaluationsPagination } from "./useTriggerEvaluationsPagination";

interface TriggerEvaluationsForTriggerProps {
  triggerId?: string;
  triggerName?: string;
  triggerType?: TriggerType;
}

const COLUMNS: Record<string, EvaluationColumn> = {
  Dataset: "dataset_id",
  Cause: "cause",
  "Evaluation Start": "evaluation_start",
  "Evaluation End": "evaluation_end",
  Status: "status",
  "Status Detail": "status_detail",
  Outcome: "outcome",
  Reason: "outcome_reason",
};

/*
 * Render a table of trigger evaluation records for the given trigger.
 */
export function TriggerEvaluationsForTrigger({
  triggerId,
  triggerName,
  triggerType,
}: TriggerEvaluationsForTriggerProps) {
  const filter = { triggerId, triggerName, triggerType };
  const {
    page,
    rowsPerPage,
    evaluationsQuery,
    countQuery,
    handlePageChange,
    handleRowsPerPageChange,
  } = useTriggerEvaluationsPagination(filter);

  const headers = Object.entries(COLUMNS).map(([label, column]) => (
    <RobotoTableCell key={column}>{label}</RobotoTableCell>
  ));

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>{headers}</TableRow>
        </TableHead>
        <TriggerEvaluationsTableBody
          columns={Object.values(COLUMNS)}
          page={page}
          rowsPerPage={rowsPerPage}
          evaluationsQuery={evaluationsQuery}
        />
      </Table>
      <TriggerEvaluationsPagination
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        hasNextPage={evaluationsQuery.hasNextPage ?? false}
        totalCount={countQuery.data ?? evaluationsQuery.data?.length ?? 0}
      />
    </TableContainer>
  );
}
